<mat-card>
  <mat-card-header style="background: inherit;align-items: center; margin-bottom:10px;" fxLayout="row" fxLayoutAlign="start center" [ngSwitch]="viewModel.dataSourceType">
    <div mat-card-avatar  [style.width.px]="width" style="margin-left: 20px;margin-top: 8px;">
      <img [src]="iconpath" width={{width}}/></div>
    <mat-card-title style="margin-left: 19px;">
      <a class="refinerylink" (click)="onRefineryNodeLinkClick()">{{refineryName}} -> </a> {{viewModel.dataTransformConfigViewModel.name}} : <span [ngStyle]="{color: nodeViewModel.nodeColor}">{{nodeViewModel.descriptor}}</span>
    </mat-card-title>
    <div fxFlex></div>
    <div style="text-align: right;white-space: nowrap;">
      <!-- Read-Only indicator: this tab doesn't hold the Edit lock for this
           refinery. Save/Reset/Paste/Import are disabled below; this makes
           WHY visible instead of leaving the Analyst to guess. -->
      <span *ngIf="isReadOnly" matTooltipClass="custom-mat-tooltip"
            matTooltip="You can view this node's configuration and output, but changes require Edit mode."
            style="margin-right: 8px; padding: 2px 10px; border-radius: 10px; background: #5a2d2d; color: #f2c2c2; font-size: 12px; font-weight: 600; letter-spacing: .04em;">
        <mat-icon style="vertical-align: middle; font-size: 16px; height: 16px; width: 16px;">visibility</mat-icon>
        READ-ONLY
      </span>
      <button mat-button *ngIf="cacheStatus">
          <mat-icon class="primary-color-icon"style=" margin-right: 2px;font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;" (click)="getCacheStatus()">
              refresh
          </mat-icon>
          <span [ngClass]="{ 'cached': cacheStatus==='Cached', 'not-cached': cacheStatus!=='Cached' }"> {{cacheStatus}} </span>
      </button>
      <ng-container *ngIf="rootStepper?.selectedIndex === 0">
        
        <button mat-icon-button matTooltip="Paste Config" (click)="pasteIngestConfig()" [disabled]="isReadOnly" style="color: rgb(247, 246, 240)">
          <img src="assets/images/Paste JSON Button.png"
              alt="Paste Config Button"
              style="margin-right: 2px;font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;" />
        </button>

        <button mat-icon-button matTooltip="Copy Config" (click)="copyIngestConfig()" style="color: rgb(247, 246, 240)">
          <img src="assets/images/Copy JSON Button.png"
              alt="Copy Config"
              style="margin-right: 2px;font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;" />
        </button>

        <button mat-icon-button matTooltip="Import Ingest Config" (click)="ingestConfigFileInput.click()" [disabled]="isReadOnly" style="color: rgb(247, 246, 240)">
          <mat-icon style="margin-right: 2px;font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;">file_upload</mat-icon>
        </button>
        <input #ingestConfigFileInput type="file" hidden accept=".json" [disabled]="isReadOnly" (change)="importIngestConfig($event)">

        <button mat-icon-button matTooltip="Export Ingest Config" (click)="exportIngestConfig()" style="color: rgb(247, 246, 240)">
          <mat-icon style="margin-right: 2px;font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;">file_download</mat-icon>
        </button>
      </ng-container>
      <button style="color: rgb(247, 246, 240)" mat-button (click)="saveMappingConfig()" [disabled]="isReadOnly">
        <mat-icon class="save-icon" style="margin-right: -5px;">save</mat-icon>
        <mat-icon class="play-icon" style="margin-right: 6px;">play_arrow</mat-icon>
        {{saveButtonText}}
      </button>
      <button style="color: rgb(247, 246, 240)" mat-button (click)="ResetNode()" [disabled]="isReadOnly">
        <mat-icon class="reset-icon" style="margin-right: 1px;">refresh</mat-icon>
        Reset Node
      </button>
      <button style="color: rgb(247, 246, 240)" mat-button>
        <mat-icon class="help-icon" style="margin-right: 1px;">help</mat-icon>
        About...
      </button>
       <!-- <i class="fa-solid fa-question primary-color-icon help-icon" style="margin-right: 1px;"></i><span style="font-size: 14px; font-weight: 500; vertical-align: middle;margin-right:5px;">About...</span> -->
    </div>
  </mat-card-header>
  <mat-card-content>
    <mat-horizontal-stepper #rootStepper linear="false">
      <mat-step [completed]="viewModel.steps[0].isComplete">
        <ng-template matStepLabel><span [class]="viewModel.steps[0].colorClass">{{viewModel.steps[0].name}} 1</span></ng-template>
        <app-ingest-work-flow-layout [configWorkflowStepper]="rootStepper" [isReadOnly]="isReadOnly"
          [configWorkflowStep]="viewModel.steps[0]" [dataTransformConfigViewModel]="viewModel.dataTransformConfigViewModel" (saveIngest)="saveIngest($event)">
        </app-ingest-work-flow-layout>
      </mat-step>
      <mat-step *ngIf="viewModel.dataTransformConfigViewModel.dataSourceType === DataSourceType.timeStampedData"
        [completed]="viewModel.steps[1].isComplete" optional #transformStep>
        <ng-template matStepLabel><span [class]="viewModel.steps[1].colorClass">{{viewModel.steps[1].name}}</span></ng-template>
        <ng-container *ngIf="rootStepper.selected === transformStep">
          <app-transformer-work-flow-layout 
            [transforms]="viewModel.dataTransformConfigViewModel.subTaskTransforms"
            [configWorkflowStepper]="rootStepper" 
            [dataFarmType]="DataFarmType.subTask" 
            [configWorkflowStep]="viewModel.steps[1]"
            [configWorkflowStepper]="rootStepper"
            [dataTransformConfigViewModel]="viewModel.dataTransformConfigViewModel"></app-transformer-work-flow-layout>
        </ng-container>
      </mat-step>
      <mat-step *ngIf="viewModel.dataTransformConfigViewModel.dataSourceType === DataSourceType.timeStampedData"
        [completed]="viewModel.steps[2].isComplete" optional #transformStep>
        <ng-template matStepLabel><span [class]="viewModel.steps[2].colorClass">{{viewModel.steps[2].name}}</span></ng-template>
        <ng-container *ngIf="rootStepper.selected === transformStep">
          <app-transformer-work-flow-layout 
            [configWorkflowStepper]="rootStepper" 
            [transforms]="viewModel.dataTransformConfigViewModel.taskTransforms"
            [dataFarmType]="DataFarmType.task" 
            [configWorkflowStep]="viewModel.steps[2]" 
            [configWorkflowStepper]="rootStepper"
            [dataTransformConfigViewModel]="viewModel.dataTransformConfigViewModel"></app-transformer-work-flow-layout>
        </ng-container>
      </mat-step>
      <mat-step *ngIf="viewModel.dataTransformConfigViewModel.dataSourceType === DataSourceType.timeStampedData"
        [completed]="viewModel.steps[3].isComplete" optional #transformStep>
        <ng-template matStepLabel><span [class]="viewModel.steps[3].colorClass">{{viewModel.steps[3].name}}</span></ng-template>
        <ng-container *ngIf="rootStepper.selected === transformStep">
          <app-transformer-work-flow-layout 
            [configWorkflowStepper]="rootStepper" 
            [transforms]="viewModel.dataTransformConfigViewModel.activityTransforms"
            [dataFarmType]="DataFarmType.activity" 
            [configWorkflowStep]="viewModel.steps[3]" 
            [configWorkflowStepper]="rootStepper"
            [dataTransformConfigViewModel]="viewModel.dataTransformConfigViewModel"></app-transformer-work-flow-layout>
        </ng-container>
      </mat-step>
      <mat-step [completed]="viewModel.steps[4].isComplete">
        <ng-template matStepLabel><span [class]="viewModel.steps[4].colorClass">{{viewModel.steps[4].name}}</span></ng-template>
        <app-config-review-work-flow-layout></app-config-review-work-flow-layout>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-card-content>
</mat-card>
